import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useTermAndConditionsSections } from '../../hooks';

const TermsAndConditionsDisplay = ({ title, children, withBackground }) => {
  const { loading, termSections } = useTermAndConditionsSections();
  return (
    <Box paddingTop={0} paddingLeft={2} backgroundColor={withBackground ? 'gray.A100' : 'transparent'} borderRadius={3} height={"100%"}>
      {loading ? (
        <Grid item xs={12} display="flex" justifyContent="center" alignItems="center" height={"100%"}>
          <CircularProgress />
        </Grid>
      ) : (
        <Grid container height={"100%"}>
          <Grid item xs={12}>
            <Typography variant="small_3" color="gray.A500" fontWeight={700}>
              {title}
            </Typography>
          </Grid>
          <Grid item xs={12} md={12} sx={{ maxHeight: 350, overflowY: 'auto', marginLeft: 1.5 }} height={"85%"}>
            <Grid
              container
              alignItems="flex-start"
              height={"100%"}
            >
              <Grid item xs={12} height={"100%"}>
                {termSections}
              </Grid>
            </Grid>
          </Grid>
          {children && (
            <Grid item xs={12}>
              {children}
            </Grid>
          )}
        </Grid>
      )}
    </Box>
  );
};

TermsAndConditionsDisplay.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  withBackground: PropTypes.bool,
};

TermsAndConditionsDisplay.defaultProps = {
  title: 'Términos y Condiciones',
  children: null,
  withBackground: true,
};

export default TermsAndConditionsDisplay;
